export default __webpack_public_path__ + "static/media/moviindex-home.56f1a2fb.png";